import { getDateDifference, isDateBetweenInclusive } from './date';

/**
 * Function to check if the attendance is unfrozen.
 *
 * @param workDate
 * @param unfreezeRequests
 * @returns
 */
export const checkAttendanceUnfrozen = (
  workDate: string,
  unfreezeRequests: Array<{ unfreezeFrom: string; unfreezeTo: string; updatedAt: string; isUnfrozen: boolean }>
): boolean => {
  if (!unfreezeRequests?.length) {
    return false;
  }

  const filteredRequests = unfreezeRequests
    .filter((request) => isDateBetweenInclusive(workDate, request.unfreezeFrom, request.unfreezeTo))
    .sort((a, b) => getDateDifference(a.updatedAt, b.updatedAt));

  const latestUnfreezeRequest = filteredRequests[0];

  if (!latestUnfreezeRequest) {
    return false;
  }

  return latestUnfreezeRequest.isUnfrozen;
};
